import React from "react";
import { Link } from "gatsby";
import "./no-code-services.css";

const services = [
  {
    title: "Product Strategy",
    slug: "product-strategy",
    icon: "pe-7s-light",
    description:
      "Clarify your problem, audience, and product roadmap before development begins.",
  },
  {
    title: "Idea Validation",
    slug: "idea-validation",
    icon: "pe-7s-science",
    description:
      "Test your assumptions with real users to avoid costly misfires.",
  },
  {
    title: "Web Application Development",
    slug: "web-application",
    icon: "pe-7s-display1",
    description:
      "Fast, secure, and scalable web apps built to grow with your business.",
  },
  {
    title: "Mobile App Development",
    slug: "mobile-application",
    icon: "pe-7s-phone",
    description:
      "Cross-platform mobile apps with consistent performance and user experience.",
  },
  {
    title: "High-Conversion Websites",
    slug: "website",
    icon: "pe-7s-browser",
    description:
      "Websites engineered to communicate value, build trust, and drive action.",
  },
  {
    title: "Product Growth",
    slug: "product-growth",
    icon: "pe-7s-loop",
    description:
      "Continuous improvements powered by data, experiments, and real user behavior.",
  },
  {
    title: "Product Marketing",
    slug: "product-marketing",
    icon: "pe-7s-speaker",
    description:
      "Positioning, messaging, and go-to-market strategies that attract the right users.",
  },
];

const NoCodeServices = () => {
  return (
    <section className="services no-code-services box lficon section-padding position-re">
      <div className="container">
      <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <div className="sec-head  text-center">
              <h3 className="wow color-font">
              Your Full-Stack No-Code Product Partner
              </h3>
            </div>
          </div>
        </div>
        {/* ROW 1 – two wide cards */}
        <div className="row">
          {services.slice(0, 2).map((service, index) => (
            <div
              key={service.slug}
              className="col-lg-6 wow fadeInLeft"
              data-wow-delay={index === 0 ? ".5s" : ".7s"}
            >
              <div className="item-box no-curve">
                <Link to={`/services/${service.slug}`}>
                  <div>
                    <span className={`icon color-font ${service.icon}`}></span>
                  </div>
                  <div className="cont">
                    <h6>{service.title}</h6>
                    <p>{service.description}</p>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* ROW 2 – three equal cards */}
        <div className="row">
          {services.slice(2, 5).map((service) => (
            <div
              key={service.slug}
              className="col-lg-4 wow fadeInLeft"
              data-wow-delay=".5s"
            >
              <div className="item-box no-curve">
                <Link to={`/services/${service.slug}`}>
                  <div>
                    <span className={`icon color-font ${service.icon}`}></span>
                  </div>
                  <div className="cont">
                    <h6>{service.title}</h6>
                    <p>{service.description}</p>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* ROW 3 – two wide cards */}
        <div className="row">
          {services.slice(5, 7).map((service, index) => (
            <div
              key={service.slug}
              className="col-lg-6 wow fadeInLeft"
              data-wow-delay={index === 0 ? ".5s" : ".7s"}
            >
              <div className="item-box no-curve">
                <Link to={`/services/${service.slug}`}>
                  <div>
                    <span className={`icon color-font ${service.icon}`}></span>
                  </div>
                  <div className="cont">
                    <h6>{service.title}</h6>
                    <p>{service.description}</p>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default NoCodeServices;
